var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#1F8BFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9414 25.2197L28.8838 27.1426H14.5869C14.8349 28.88 15.4545 30.425 16.4463 31.7764C17.3967 33.1663 18.5957 34.2473 20.042 35.0195C21.4882 35.8302 23.079 36.2353 24.8145 36.2354C26.5913 36.2354 28.2233 35.8493 29.7109 35.0771C30.5998 34.6158 31.3993 34.0432 32.1113 33.3613L34.9482 36.1982C34.1848 36.8644 33.349 37.4571 32.4385 37.9736C30.1244 39.3249 27.5416 40 24.6904 40C21.9218 40 19.4421 39.325 17.252 37.9736C15.0205 36.6609 13.2644 34.8649 11.9834 32.5869C10.6611 30.3476 10 27.8375 10 25.0576V23.7256H32.54L30.9414 25.2197ZM24.0088 10C26.984 10 29.6909 10.656 32.1289 11.9688C34.5257 13.3201 36.4472 15.1351 37.8936 17.4131C39.2985 19.691 40.0009 22.2393 40.001 25.0576C40.001 27.8375 39.3187 30.3475 37.9551 32.5869C37.5701 33.23 37.1453 33.8332 36.6846 34.3994L33.7119 31.4268C34.5289 30.1924 35.0711 28.7923 35.3369 27.2246H35.3389L35.3438 27.2012C35.5893 26.0371 35.6343 24.8393 35.4766 23.6602H35.4658C35.2118 21.7949 34.5756 20.118 33.5547 18.6299C32.4803 17.1241 31.0956 15.9271 29.4014 15.0391C27.7071 14.1896 25.8471 13.7646 23.8223 13.7646C22.2109 13.7647 20.641 13.9967 19.1123 14.46C17.5833 14.9233 16.3016 15.5793 15.2686 16.4287L12.417 13.5908C14.1525 12.3939 15.9713 11.4869 17.8721 10.8691C19.7316 10.29 21.7773 10 24.0088 10Z",
    fill: "url(#paint0_linear_33_997)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_997",
    x1: 29.3756,
    y1: 40,
    x2: 19.3759,
    y2: 11.8748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6ff3c8d888e50bc6c14adfa24235a3b7.svg";
export { ForwardRef as ReactComponent };